const KEY = 'kelimoTheme';
const valid = value => ['light', 'dark', 'system'].includes(value);
export function getThemePreference() { try { const value = localStorage.getItem(KEY); return valid(value) ? value : 'system'; } catch (_) { return 'system'; } }
function apply() {
  const preference = getThemePreference();
  const dark = preference === 'dark' || (preference === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  document.documentElement.dataset.themePreference = preference;
  const browserColor = document.querySelector('meta[name="theme-color"]');
  if (browserColor) browserColor.setAttribute('content', dark ? '#08272C' : '#124B51');
}
export function setThemePreference(value) { if (!valid(value)) return; try { localStorage.setItem(KEY, value); } catch (_) {} apply(); window.dispatchEvent(new CustomEvent('kelimo-theme-change')); }
export function initializeTheme() {
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  apply(); media.addEventListener('change', apply);
  const sync = event => { if (event.key === KEY || event.key === null) apply(); };
  window.addEventListener('storage', sync);
  return () => { media.removeEventListener('change', apply); window.removeEventListener('storage', sync); };
}
